import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Product } from '../domain/product';
import { MessageService, ConfirmationService } from 'primeng/api';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { Router } from '@angular/router';
import { IUser } from 'app/shared/Domains/IUser';
import { AuthService } from 'common/services/auth.service';
import { AppServiceManager } from 'common/services/appServiceManager';
import { ICompany } from 'app/shared/Domains/company';
import { IRole } from 'app/shared/Domains/role';
import { Configuration } from 'config/config';
import { NgxSpinnerService } from 'ngx-spinner';
import { IBranch } from 'app/shared/Domains/branch';
import { LanguageService } from 'app/LanguageService/Language.Service';

@Component({
  selector: 'app-products-listing',
  templateUrl: './products-listing.component.html',
  host: { "(window:keyup)": "hotkeys($event)" },
  styleUrls: ['./products-listing.component.css']
})
export class ProductsListingComponent implements OnInit {
  @ViewChild("searchProduct", { static: false }) searchProductInput: ElementRef;
  tabIndex: number = 0;
  minQuantity: number;
  user: IUser;
  loading: boolean;
  products: any[];
  readyToSellProducts: any[];
  ingredientsBasedProducts: any[];
  ingredientsProducts: any[];
  product: Product;
  imgPreview: boolean = false;
  imgPreviewImg: any;
  sourceProducts: any[];
  sourceReadyToSellProducts: any[];
  sourceingredientsBasedProducts: any[];
  sourceingredientsProducts: any[];
  first: number = 0;
  company: ICompany;
  role: IRole;
  branch: IBranch;

  constructor(
    private LanguageService: LanguageService,
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    private route: Router,
    public config: Configuration,
    private appServiceManager: AppServiceManager,
    private confirmationService: ConfirmationService,
    private loader: NgxSpinnerService,

  ) {
    this.breadcrumbService.setItems([
      { label: 'Products' }
    ]);
  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("ProductsListingComponent", label);
  }
  ngOnInit() {
    this.user = AuthService.getLoggedInUser();
    this.role = AuthService.getLoggedInRole();
    this.company = new ICompany();
    this.getCompany();
    this.getBranch();
    this.getProducts();
    this.imgPreviewImg = "";
    this.products = [];
    this.product = new Product();
  }

  ngAfterViewInit() {
    this.searchProductInput.nativeElement.focus();
  }

  getCompany() {
    this.company = AuthService.getLoggedInCompanyBranch();
    if(!this.company){
    this.appServiceManager.get("companies/" + this.user.company).subscribe(
      (res) => {
        if (res) {
          this.company = res;
        } else {
          this.company = new ICompany();
          this.messageService.clear();
          this.messageService.add({
            severity: "info",
            summary: "Info Message",
            detail: "Something Went Wrong",
          });
        }
      },
      (error) => {
        this.company = new ICompany();
        this.messageService.clear();
        this.messageService.add({
          severity: "error",
          summary: "Error Message",
          detail: error,
        });
      }
    );
   }
  }
  getBranch() {
    this.branch = AuthService.getLoggedInCurrentBranch();
    if(!this.branch){
    this.appServiceManager.get('branches/' + this.user.branch).subscribe((res) => {
      if (res) {
        this.branch = res;
      } else {
        this.branch = new IBranch();
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.branch = new IBranch();
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
    }
  }

  getProducts() {
    this.loading = true;
    this.loader.show();
    this.appServiceManager.get(`products/company/${this.user.company}/branch/${this.user.branch}`).subscribe((res: any) => {
      if (res.length > 0) {
        this.products = res;
        this.sourceProducts = res;

        this.readyToSellProducts = this.products.filter(product => product.type == "Ready to Sell");
        this.sourceReadyToSellProducts = this.readyToSellProducts;

        this.ingredientsBasedProducts = this.products.filter(product => product.type == "Ingredients Based");
        this.sourceingredientsBasedProducts = this.ingredientsBasedProducts;

        this.ingredientsProducts = this.products.filter(product => product.type == "Ingredients");
        this.sourceingredientsProducts = this.ingredientsProducts;
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
      this.loading = false;
      this.loader.hide();
    },
      (error) => {
        this.loading = false;
        this.loader.hide();
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  //Status based filtering
  handleTabChange(e) {
    var index = e.index;
    if (index == 0) {
      this.tabIndex = 0;
    }
    if (index == 1) {
      this.tabIndex = 1;
    }
    if (index == 2) {
      this.tabIndex = 2;
    }
  }

  openPhoto(imgUri) {
    this.imgPreview = true;
    this.imgPreviewImg = imgUri;
  }

  closePhotoPreview() {
    this.imgPreview = false;
    this.imgPreviewImg = "";
  }

  // deleteProducte(e) {

  // }

  viewProduct(product) {
    this.route.navigateByUrl('product/' + product._id)
  }


  deleteProduct(product) {
    this.confirmationService.confirm({
      message: "Are you sure you want to Delete ?",
      accept: () => {
        this.loading = true;
        this.appServiceManager.delete('products/' + product._id).subscribe((res: any) => {
          if (res.status === true) {
            this.DeleteProduct(product);
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Deleted' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
          this.loading = false;
          this.products = [...this.products]
        },
          (error) => {
            this.loading = false;
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      }
    });
  }
  DeleteProduct(product) {
    let products = [...this.products];
    let index = this.products.indexOf(product);
    if (index > -1) {
      products.splice(index, 1);
      return this.products = products;
    }
  }

  searchLocal(value, type) {
    let matchedName = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.products = Object.assign([], this.sourceProducts);
      }
      if (!value) {
        this.products = Object.assign([], this.sourceProducts);
      }
      if (value != "") {
        if (type === "name") {
          matchedName = Object.assign([], this.sourceProducts).filter(
            cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
        }

        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedName;
        this.products = source.filter(distinct);

        if (this.products.length === 0) {
          this.products = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.first = 0;
          if (this.products.length === 1) {
            this.first = 0;
          }
          this.products = [...this.products];
        }
      }
    } else {
      this.products = Object.assign([], this.sourceProducts);
      this.products = [...this.products];
    }
  }

  searchReadytoSell(value, type) {
    let matchedName = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.readyToSellProducts = Object.assign([], this.sourceReadyToSellProducts);
      }
      if (!value) {
        this.readyToSellProducts = Object.assign([], this.sourceReadyToSellProducts);
      }
      if (value != "") {
        if (type === "name") {
          matchedName = Object.assign([], this.sourceReadyToSellProducts).filter(
            cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
        }

        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedName;
        this.readyToSellProducts = source.filter(distinct);

        if (this.readyToSellProducts.length === 0) {
          this.readyToSellProducts = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.first = 0;
          if (this.readyToSellProducts.length === 1) {
            this.first = 0;
          }
          this.readyToSellProducts = [...this.readyToSellProducts];
        }
      }
    } else {
      this.readyToSellProducts = Object.assign([], this.sourceReadyToSellProducts);
      this.readyToSellProducts = [...this.readyToSellProducts];
    }
  }

  searchIngredientsBased(value, type) {
    let matchedName = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.ingredientsBasedProducts = Object.assign([], this.sourceingredientsBasedProducts);
      }
      if (!value) {
        this.ingredientsBasedProducts = Object.assign([], this.sourceingredientsBasedProducts);
      }
      if (value != "") {
        if (type === "name") {
          matchedName = Object.assign([], this.sourceingredientsBasedProducts).filter(
            cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
        }

        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedName;
        this.ingredientsBasedProducts = source.filter(distinct);

        if (this.ingredientsBasedProducts.length === 0) {
          this.ingredientsBasedProducts = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.first = 0;
          if (this.ingredientsBasedProducts.length === 1) {
            this.first = 0;
          }
          this.ingredientsBasedProducts = [...this.ingredientsBasedProducts];
        }
      }
    } else {
      this.ingredientsBasedProducts = Object.assign([], this.sourceingredientsBasedProducts);
      this.ingredientsBasedProducts = [...this.ingredientsBasedProducts];
    }
  }

  searchIngredients(value, type) {
    let matchedName = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.ingredientsProducts = Object.assign([], this.sourceingredientsProducts);
      }
      if (!value) {
        this.ingredientsProducts = Object.assign([], this.sourceingredientsProducts);
      }
      if (value != "") {
        if (type === "name") {
          matchedName = Object.assign([], this.sourceingredientsProducts).filter(
            cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
        }

        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedName;
        this.ingredientsProducts = source.filter(distinct);

        if (this.ingredientsProducts.length === 0) {
          this.ingredientsProducts = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.first = 0;
          if (this.ingredientsProducts.length === 1) {
            this.first = 0;
          }
          this.ingredientsProducts = [...this.ingredientsProducts];
        }
      }
    } else {
      this.ingredientsProducts = Object.assign([], this.sourceingredientsProducts);
      this.ingredientsProducts = [...this.ingredientsProducts];
    }
  }

  clear() {
    this.product = new Product();
    this.searchLocal("", "");
    this.searchReadytoSell("", "");
    this.searchIngredientsBased("", "");
    this.searchIngredients("", "");
    this.first = 0;
  }

  onPageChange(event) {
    this.first = event.first;
  }

  printProductsStockQuantity(): void {
    let printContents, popupWin;
    printContents = document.getElementById("overallProductsStockPrint").innerHTML;
    popupWin = window.open(
      "",
      "_blank",
      "top=0,left=0,height=100%,width=auto"
    );
    popupWin.document.open();
    popupWin.document.write(`
      <html>
      <head>
        <title>Gym Invoice</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.information table td {
                padding-bottom: 40px;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
      </head>
      <body>${printContents}</body>
      </html>
    `);
  }

  hotkeys($event) {
    if ($event.keyCode == 113) {
      this.route.navigateByUrl("/product");

    }
  }

}
